export const useTheme = () => {
  const isDark = useState<boolean>('theme:dark', () => false)
  const themeAuto = useState<boolean>('theme:auto', () => false)
  let mediaQuery: MediaQueryList | null = null

  const applyDark = (dark: boolean) => {
    isDark.value = dark
    if (process.client) {
      document.documentElement.classList.toggle('dark', dark)
    }
  }

  const handleSystemChange = (e: MediaQueryListEvent) => applyDark(e.matches)

  const stopFollowingSystem = () => {
    if (mediaQuery) {
      mediaQuery.removeEventListener('change', handleSystemChange)
      mediaQuery = null
    }
  }

  // Manually flipping the switch always wins over auto mode — covers both the
  // Personalization page toggle and the sidebar's quick theme button.
  const toggleTheme = () => {
    if (themeAuto.value) {
      themeAuto.value = false
      stopFollowingSystem()
    }
    applyDark(!isDark.value)
    if (process.client) {
      localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
    }
  }

  const setThemeAuto = (enabled: boolean) => {
    themeAuto.value = enabled
    if (!process.client) return
    if (enabled) {
      localStorage.setItem('theme', 'system')
      mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      applyDark(mediaQuery.matches)
      mediaQuery.addEventListener('change', handleSystemChange)
    } else {
      stopFollowingSystem()
      localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
    }
  }

  const initTheme = () => {
    if (process.client) {
      const savedTheme = localStorage.getItem('theme')
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

      if (savedTheme === 'system' || !savedTheme) {
        themeAuto.value = true
        applyDark(prefersDark)
        mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        mediaQuery.addEventListener('change', handleSystemChange)
      } else {
        applyDark(savedTheme === 'dark')
      }
    }
  }

  return {
    isDark: readonly(isDark),
    themeAuto: readonly(themeAuto),
    toggleTheme,
    setThemeAuto,
    initTheme
  }
}
